import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {SDKProvider} from "@tma.js/sdk-react";

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

try {
  const webApp = (window as any).Telegram.WebApp;
  webApp.requestFullscreen();
} catch {}

root.render(
    <SDKProvider>
        <App/>
    </SDKProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
